// react
import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputAdornment from '@material-ui/core/InputAdornment';

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import LoadingIcon from "@material-ui/icons/Cached";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';
import {MaskCEP, MaskCel,MaskCPFCNPJ, transformValueFormatedtoFloat, transformValueFloattoFormated} from "beaktShared/helpers/masks";
import {medeString} from "beaktShared/helpers/extras.js";



// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UseGetApiendPointDiferent } from "beaktShared/services/crudeApiService";
import { getAvaliacaoCookie } from "beaktClinic/services/avaliacaoCookie";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);
 
export default function FornecedoresForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register,unregister, handleSubmit, setValue, errors, clearError,setError } = useForm({mode: "onChange"});
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);

    const [loadingCep,setloadingCep] = React.useState(false);
    const [loadingValidateCNPJ, setloadingValidateCNPJ] = React.useState(false);
    

    const handleCEPBlur = (e) =>{
        let cep = e.target.value; 
        if(cep==="")
            return;
        cep = cep.replace("-","");

        setloadingCep(true);
        const endPoint = "https://viacep.com.br/ws/"+cep+"/json";
        UseGetApiendPointDiferent(endPoint).then(result=>{       
            if(result.status !== 200)
            {                                     
                //showNotification(result.message,'danger');   
                setloadingCep(false); 
                return false; 
            } 
            let resultcep = result.data; 
            setValue('logradouro', resultcep.logradouro);
            setValue('bairro', resultcep.bairro);
            setValue('cidade', resultcep.localidade);
            setValue('uf', resultcep.uf);
            setloadingCep(false);                    
        }); 
    };
     const handleCnpjBlur = (e) =>{
         let cnpj = e.target.value; 
         if(cnpj==="")
             return;
         cnpj = cnpj.split(".").join("").split("/").join("").split("-").join("").trim();
            
         setloadingValidateCNPJ(true);
         const endPoint = "Fornecedores/bycnpj/"+cnpj+"/"+session.estabelecimentoId;
         UseGetApiSimple(endPoint,0).then(result=>{     
             if(result.status === 200)
             {
                 LoadDadosItem(result.data);
                 setloadingValidateCNPJ(false);  
                 return true;
             }  

             setloadingValidateCNPJ(false);                    
         });
    }

    const intialValues = {
        id:0,
        fantasia:'',
        cnpj:'',
        contato:'',
        fone:'',
        fone2:'',
        celular:'',
        email:'',
        cep:'',
        logradouro:'',
        complemento:'',
        numero:'',
        bairro:'',
        cidade:'',
        uf:'',
        ativo:true,
    };
    useEffect(() => {
        LoadDadosItem(item);
    // eslint-disable-next-line
    }, [item]);
    const LoadDadosItem =(item) =>{
        if(!item.fornecedorId)
            return;    
        setValue('id', item.fornecedorId);     
        setValue('fantasia', item.fantasia); 
        setValue('cnpj', item.cnpj);        
        setValue('contato', item.contato);
        setValue('fone', item.fone);
        setValue('fone2', item.fone2);
        setValue('celular', item.celular);
        setValue('email', item.email);
        setValue('cep', item.cep);
        setValue('logradouro', item.logradouro);
        setValue('complemento', item.complemento);
        setValue('numero', item.numero);
        setValue('bairro', item.bairro);
        setValue('cidade', item.cidade);
        setValue('uf', item.uf);
        setValue("fornecedorGrupo", item.fornecedorGrupoId); 
        setAtivoCheckbox(item.ativo);
    }
    
    useEffect(() => {
        if(!item.fornecedorId)
            return;    
        setValue('id', item.fornecedorId);     
        setValue('fantasia', item.fantasia); 
        setValue('cnpj', item.cnpj);        
        setValue('contato', item.contato);
        setValue('fone', item.fone);
        setValue('fone2', item.fone2);
        setValue('celular', item.celular);
        setValue('email', item.email);
        setValue('cep', item.cep);
        setValue('logradouro', item.logradouro);
        setValue('complemento', item.complemento);
        setValue('numero', item.numero);
        setValue('bairro', item.bairro);
        setValue('cidade', item.cidade);
        setValue('uf', item.uf);
        setValue("fornecedorGrupo", item.fornecedorGrupoId); 
        setAtivoCheckbox(item.ativo); 

    }, [item]);
    
    const validaCampos = data =>{
        let existerror = false;
        let str = medeString(data.fone);
        
        if(str < 10) 
        {
            setError("fone","required");
            existerror = true;
        }
        str = medeString(data.fone2);
        if(str > 0 && str < 10){
            setError("fone2","required");
            existerror = true;
        }
        str = medeString(data.celular);
        if(str > 0 && str < 11){
            setError("celular","required");
            existerror = true;
        }   
        return existerror;
    };
    

    const onSubmit = data => {                          
        if(validaCampos(data)){
            return
        }

        addItem({
            fornecedorId:parseInt(data.id),
            fantasia:data.fantasia,
            cnpj:data.cnpj,
            contato:data.contato,
            fone:data.fone,
            fone2:data.fone2,
            celular:data.celular,
            email:data.email,
            cep:data.cep,
            logradouro:data.logradouro,
            complemento:data.complemento,
            numero:data.numero,
            bairro:data.bairro,
            cidade:data.cidade,
            uf:data.uf,
            ativo:ativoCheckbox,
            usuarioCadastroId:session.id,
            lancadoPor : (session.estabelecimentoId == 0 ? "Franquia" : "Estabelecimento"),
            franquiaId: (session.franquiaId == 0 ? null : session.franquiaId)
        });        
    };

    const handleViewForm = () => {
        handleView();
    };

    return (
        <div className="maxContent">              
            <form onSubmit={handleSubmit(onSubmit)}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <PermIdentity />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('sidebar.supplier_register')} - <small>{t('information_message.fill_in_your_details')}</small>
                                <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} />
                            </h4>
                        </CardHeader>
                        <CardBody>                            
                            <GridContainer>
                                <GridItem xs={12} sm={4} md={4}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.cnpj?true:false}
                                        label={t('label.cpf')+" / "+t('label.cnpj')+" *"}
                                        variant="outlined"
                                        inputRef={register({required: true})}
                                        name="cnpj"
                                        onBlur={handleCnpjBlur}
                                        defaultValue={intialValues.cnpj}
                                        InputLabelProps={{shrink: true}}
                                        InputProps={{
                                            inputComponent: MaskCPFCNPJ,
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                {loadingValidateCNPJ && <LoadingIcon className="rotate" />}
                                              </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                    {errors.cnpj && <span>{t('label.required')}</span>}
                                    </FormHelperText>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={8}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.fantasia?true:false}
                                        label={t('label.fantasy')+" *"}
                                        variant="outlined"
                                        inputRef={register({required: true})}
                                        name="fantasia"
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 150}}
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.fantasia && <span>{t('label.required')}</span>}
                                    </FormHelperText>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={4} md={4}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.contato?true:false}
                                        label={t('label.contact')+" *"}
                                        variant="outlined"
                                        inputRef={register({required: true})}
                                        name="contato"
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 150}}
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.contato && <span>{t('label.required')}</span>}
                                    </FormHelperText>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={8}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.email?true:false}
                                        label={t('label.email')}
                                        variant="outlined"
                                        inputRef={register({
                                            required: true,
                                            pattern: {
                                                value: /^\S+@\S+$/i,
                                                message: t('label.invalid_email')
                                            },
                                            maxLength: {
                                                value:300,
                                                message: t('label.enter_a_maximum_of_50_characters')
                                            }
                                        })}
                                        name="email"
                                        defaultValue={intialValues.email}
                                        InputLabelProps={{shrink: true}}
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.email && <span>{errors.email.message}</span>}
                                    </FormHelperText>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={4} md={4}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.fone?true:false}
                                        label={t('label.telephone')}
                                        variant="outlined"
                                        inputRef={register({required: true })}
                                        name="fone"
                                        InputProps={{
                                            inputComponent: MaskCel,
                                        }}
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 20, minLength:11}}
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.fone && <span>{t('label.required')}</span>}
                                    </FormHelperText>
                                    </FormControl>
                                </GridItem>

                                <GridItem xs={12} sm={4} md={4}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.fone2?true:false}
                                        label={t('label.telephone')+"2"}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="fone2"
                                        InputProps={{
                                            inputComponent: MaskCel,
                                        }}
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 20}}
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.fone2 && <span>{t('label.invalid_phone')}</span>}
                                    </FormHelperText>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={4} md={4}>
                                    <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.celular?true:false}
                                        label={t('label.cell_phone')}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        name="celular"
                                        InputProps={{
                                            inputComponent: MaskCel,
                                        }}
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 20}}
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.celular && <span>{t('label.invalid_phone')}</span>}
                                    </FormHelperText>
                                    </FormControl>
                                </GridItem>
                            </GridContainer>
                            <GridContainer>
                                <GridItem xs={12} sm={3} md={3}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField                                        
                                        error={errors.cep?true:false}
                                        label={t('label.zip_code')}
                                        variant="outlined"
                                        inputRef={register({required: true})}
                                        name="cep"
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 10}}
                                        onBlur={handleCEPBlur}
                                        InputProps={{
                                            inputComponent: MaskCEP,
                                            endAdornment: (
                                            <InputAdornment position="end">
                                                {loadingCep && <LoadingIcon className="rotate" />}
                                            </InputAdornment>
                                            ),
                                        }}                          
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.cep && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>
                                <GridItem xs={12} sm={3} md={4}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField                                        
                                        error={errors.logradouro?true:false}
                                        label={t('label.address')}
                                        variant="outlined"                                    
                                        inputRef={register({required: true})}
                                        name="logradouro"
                                        InputLabelProps={{shrink: true}}   
                                        inputProps={{maxLength: 150}}                          
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.logradouro && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>
                                <GridItem xs={12} sm={3} md={3}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField                                        
                                        error={errors.conplemento?true:false}
                                        label={t('label.complement')}
                                        variant="outlined"                                    
                                        inputRef={register({required: false})}
                                        name="complemento"
                                        InputLabelProps={{shrink: true}}   
                                        inputProps={{maxLength: 20}}                          
                                    />
                                    </FormControl>                                 
                                </GridItem>
                                <GridItem xs={12} sm={3} md={2}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField                                        
                                        error={errors.numero?true:false}
                                        label={t('label.number')+" *"} 
                                        variant="outlined"                                    
                                        inputRef={register({required: true})}
                                        name="numero"
                                        InputLabelProps={{shrink: true}}   
                                        inputProps={{maxLength: 10}}                          
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.numero && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>  
                                                                   
                                </GridItem>
                                <GridItem xs={12} sm={3} md={3}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField                                        
                                        error={errors.bairro?true:false}
                                        label={t('label.neighborhood')}
                                        variant="outlined"                                    
                                        inputRef={register({required: true})}
                                        name="bairro"
                                        InputLabelProps={{shrink: true}}   
                                        inputProps={{maxLength: 150}}                          
                                    
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.bairro && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>  
                                                                   
                                </GridItem>
                                <GridItem xs={12} sm={3} md={3}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField                                        
                                        error={errors.cidade?true:false}
                                        label={t('label.city')}
                                        variant="outlined"                                    
                                        inputRef={register({required: true})}
                                        name="cidade"
                                        InputLabelProps={{shrink: true}}   
                                        inputProps={{maxLength: 150}}                          
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.cidade && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>
                                <GridItem xs={12} sm={3} md={2}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField                                        
                                        error={errors.uf?true:false}
                                        label={t('label.state')}
                                        variant="outlined"                                    
                                        inputRef={register({required: true})}
                                        name="uf"
                                        InputLabelProps={{shrink: true}}   
                                        inputProps={{maxLength: 2}}                          
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.uf && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>
                                
                                <GridItem xs={12} sm={12} md={3}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                tabIndex={-1}                                                
                                                checked={ativoCheckbox}   
                                                onClick={event => {setAtivoCheckbox(event.target.checked)}}                                             
                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                icon={<Check className={classes.uncheckedIcon} />}
                                                classes={{
                                                    checked: classes.checked,
                                                    root: classes.checkRoot
                                                }}                    
                                                name="ativo"  
                                                inputRef={register}                                                    
                                            />
                                        }
                                        classes={{
                                            label: classes.label,
                                            root: classes.labelRoot
                                        }}
                                        label={t('information_message.system_active')}
                                    />
                                </GridItem>


                            </GridContainer>
                            
                            <Clearfix />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                    <br/>
                    <div className={classes.textCenter}>
                        <Button  onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')} 
                            {loading && <div> ...{t('label.loading')} </div>}
                        </Button>
                    </div>
                </GridItem>
            </GridContainer>            
            </form>
        </div>
    );
}